export interface Address {
  street?: string;
  address2?: string;
  city?: string;
  country?: string;
  createDate?: string;
  guid?: string;
  id?: number;
  lat?: number;
  lng?: number;
  modifyDate?: string;
  name?: string;
  region?: string;
  state?: string;
  zip?: string;
}
